import { createContext, useContext } from "react";

// Controls the in-app debug/QA status overlays on the LP Express renderer
// (LiveBadge / StaticBadge source pills, content SourceDot, and the green
// "AI-generated image" dot). These are authoring aids only — the in-app
// preview/builder surfaces leave this enabled, while the published public
// page (/p/:slug) sets it to false so visitors never see the indicators.
export const LpStatusDotsContext = createContext<boolean>(true);

export function useLpStatusDots(): boolean {
  return useContext(LpStatusDotsContext);
}
